import { gql } from '@apollo/client';

export const UPDATE_STYLE = gql`
    mutation updateStyle($input: UpdateStyleInput!) {
        updateStyle(input: $input) {
            taffiId
            status
        }
    }
`;

export const DUPLICATE_STYLE = gql`
    mutation duplicateStyle($input: DuplicateStyleInput!) {
        duplicateStyle(input: $input) {
            taffiId
        }
    }
`;
